var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accountRecharge"},[_c('div',{staticClass:"personal-box comWidth"},[_c('CenterNav'),_vm._v(" "),_c('div',{staticClass:"personal-right"},[_c('NavT',{attrs:{"titleS":_vm.titleS}}),_vm._v(" "),_c('div',{staticClass:"rightmain"},[_vm._v("\n\n          暫未開通，敬請期待\n\n      ")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b546368","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personalPage/assetCenterPage/AccountRecharge.vue
// module id = null
// module chunks = 